import React, { useEffect, useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import axios from "axios";
import moment from "moment";
import { AiOutlineBook } from "react-icons/ai";
import { MdBusiness } from "react-icons/md";
import { FaUsers } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import logo from "../Assets/images/M.png";
import DateRangeSelector from "../Components/filterDataRange/DateRangeSelector";
import GroupsTab from "../Components/GroupsTab";
import UsersTab from "../Components/UsersTab";
import MostVisited from "../Components/Charts/VisitPlaces";
import ActiveHours from "../Components/Charts/ActiveHours";
import Sessions from "../Components/Charts/Sessions";
import PopEnv from "../Components/Charts/PopEnv";
import PlatformVisit from "../Components/Charts/PlatformVisit";
import PlatUsers from "../Components/Charts/NewPlatUsers";
import ActivePlatUsers from "../Components/Charts/ActivePlatUsers";
import NewPlatUsers from "../Components/Charts/NewPlatUsers";
import { useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import { exportMultipleChartsToPdf } from "../utils/pdf";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { EnlargeIcon, ExpandDetailsIcon, ExpandIcon, LeftArrow, PDFDownloadIcon } from "../Assets/iconshere";
import Tooltip from "@mui/material/Tooltip";
import { humanReadable } from "../utils/useWindowDimensions";
import DateRangeFilter from "./DateRangeFilter";
import UsersRadial from "../Components/Charts/UsersRadial";
import apiClient from "../apiClient";

const TeamDashboard = () => {
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  if (!state) {
    navigate(`/team/dashboard/${userData.user.group.uuid}`, {
      state: { name: userData.user.group.name, avatar: userData.user.group.avatar, uuid: userData.user.group.uuid },
    });
  }
  const [filter, setFilter] = useState("all");
  const [activeTab, setActiveTab] = useState("Dashboard");
  const [roleList, setRoleList] = useState([]);
  const [search, setSearch] = useState("");
  const params = useParams();
  const { uuid } = params;
  const [loading, setLoading] = useState(true);
  const [groupTypesList, setGroupTypesList] = useState([]);
  const [redirected, setRedirected] = useState(false);
  const userGroupTypeId = userData?.user?.group?.typeId || null;

  const [dashboardData, setDashboardData] = useState({
    platformVisit: 0,
    platform: [],
    totalEvents: 0,
    avgEventTime: 0,
    totalUsers: 0,
    avgSessionTime: 0,
    newVisitors: 0,
    mostVisitedPlaces: [],
    activeUsers: 0,
    activeHours: [],
    popularEnvironment: [],
    sessionCreated: [],
  });

  const onGroupSelect = (group) => {
    navigate(`/team/dashboard/${group.uuid}`, { state: { name: group.name, avatar: group.avatar, uuid: group.uuid } });
  };

  const onUserSelect = (user) => {
    navigate(`/team/user/${user.uuid}`, { state: user });
  };

  const geGroupTypeList = async () => {
    try {

      const data = await apiClient.get(`${configData.config.UNO_URL}/api/role/grouptype/list`);

      // let { data } = await axios.get(`${configData.config.UNO_URL}/api/role/grouptype/list`, {
      //   headers: {
      //     Authorization: `Bearer ${userData.token}`,
      //     "Content-Type": "application/json",
      //   },
      // });
      setGroupTypesList(data?.groupTypes || []);
    } catch (error) {
      console.log(error);
    }
  };

  const geRoleTypesList = async () => {
    try {

      const data = await apiClient.get(`${configData.config.UNO_URL}/api/role/list/PRIVATE/${userGroupTypeId}`);

      // let { data } = await axios.get(`${configData.config.UNO_URL}/api/role/list/PRIVATE/${userGroupTypeId}`, {
      //   headers: {
      //     Authorization: `Bearer ${userData.token}`,
      //     "Content-Type": "application/json",
      //   },
      // });

      setRoleList(data || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (userGroupTypeId) {
      geGroupTypeList();
      geRoleTypesList();
    }
  }, [userGroupTypeId]);

  const getTeamDashboardData = async () => {
    setLoading(true);
    try {

      const data = await apiClient.get(`${configData.config.API_URL}/api/dashboard/team/report/${uuid}/${filter}`, {
        params: {
          applicationId: configData.config.applicationId
        }
      });


      // let { data } = await axios.get(`${configData.config.API_URL}/api/dashboard/team/report/${uuid}/${filter}`, {
      //   params: {
      //     applicationId: configData.config.applicationId
      //   },
      //   headers: {
      //     Authorization: `Bearer ${userData.token}`,
      //     "Content-Type": "application/json",
      //   },
      // });

      const {
        totalEvents,
        totalUsers,
        avgEventTime,
        avgSessionTime,
        activeUsers,
        newPlatformVisitors,
        popularEnvironment,
        activeHours,
        mostVisitedPlaces,
        sessionCreated,
        platformVisits,
        platform,
      } = data;

      setDashboardData({
        totalEvents: totalEvents,
        activeHours: activeHours,
        avgEventTime: avgEventTime,
        totalUsers: totalUsers,
        avgSessionTime: avgSessionTime,
        activeUsers: activeUsers.activeUsers,
        popularEnvironment: popularEnvironment,
        newVisitors: newPlatformVisitors.newVisitors,
        mostVisitedPlaces: mostVisitedPlaces,
        sessionCreated: sessionCreated,
        platformVisit: platformVisits,
        platform: platform,
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setActiveTab("Dashboard");
    getTeamDashboardData();
  }, [uuid, filter]);

  const tableData1 = [
    ["TeamDashBoard", ""],
    ["Name", userData?.user?.name],
    ["Events", dashboardData?.totalEvents],
    ["Average Event duration", humanReadable(dashboardData?.avgEventTime)],
    ["Average Session Time", humanReadable(dashboardData?.avgSessionTime)],
    ["Report Generated at ", moment().format("ll")],
  ];
  return (
    <>
      <div className="container-fluid p-0">
        <div className="col-md-12">
          <Tab.Container id="my-tabs" activeKey={activeTab} defaultActiveKey="Dashboard">
            <div className="col-md-12">
              <Nav className="tabsproduct updated toptab" variant="tabs">
                <Nav.Item>
                  <Nav.Link
                    onClick={() => {
                      setActiveTab("Dashboard");
                      setRedirected(false);
                    }}
                    eventKey="Dashboard"
                  >
                    Dashboard
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link onClick={() => setActiveTab("Groups")} eventKey="Groups">
                    Groups
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link onClick={() => setActiveTab("Users")} eventKey="Users">
                    Users
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </div>

            <div className="container-fluid admindashboard bg-grey-main main-parent-padding">
              <Tab.Content className="pt-3">
                <Tab.Pane eventKey="Dashboard">
                  <div className="row">
                    <div className="bg-grey-main dashboard p-3 px-0">
                      <div className="container-fluid">
                        <div className="row py-2 mt-2">
                          <div className="col-md-6 d-flex align-items-center">
                            {state.uuid !== userData.user.group.uuid && (
                              <button onClick={() => navigate(-1)} className="backbtn cursor-pointer " title="Back">
                                <LeftArrow />
                                Back
                              </button>
                            )}
                          </div>
                          <div className="col-md-6 d-flex align-items-center justify-content-end">
                            <DateRangeSelector selected={filter} setSelected={setFilter} />
                            {/* <DateRangeFilter/> */}
                            <button
                              className="DefaultRedBtn download ms-2"
                              onClick={() => exportMultipleChartsToPdf("Team_Dashboard", tableData1)}
                            >
                              <PDFDownloadIcon />
                            </button>
                          </div>
                        </div>
                        <div className="datacardesign py-2 mb-2">
                          <div className="row h-100 ">
                            <div className="col-md-5 d-flex align-itmes-center ">
                              <div className="cardimages d-flex align-items-center gap-3 ps-3">
                                {loading ? (
                                  <Skeleton count={1} circle height="4.5vw" width="4.5vw" />
                                ) : (
                                  <>
                                    {state.avatar ? (
                                      <div className="groupcardesign m-0" style={{ height: "auto" }}>
                                        <div className="avatarimg">
                                          <img src={state.avatar} referrerPolicy={"no-referrer"} alt="" />
                                        </div>
                                      </div>
                                    ) : (
                                      <div className="usercardesign m-0" style={{ height: "auto" }}>
                                        <div className="initials-placeholder">
                                          {state?.name
                                            ?.split(" ")
                                            .map((word) => word[0])
                                            .slice(0, 2)
                                            .join("")}
                                        </div>
                                      </div>
                                    )}
                                  </>
                                )}

                                <h4 className=" group-user-name m-0">
                                  {loading ? <Skeleton count={1} width="10vw" /> : <> {state?.name || ""} </>}
                                </h4>
                              </div>
                            </div>

                            <div className="col-md-7">
                              <div className="dashstatdata">
                                <div className="welcometext">
                                  <p>{loading ? <Skeleton width="5vw" /> : <> Total Users </>}</p>
                                  {loading ? (
                                    <Skeleton width="5vw" />
                                  ) : (
                                    <span className="d-flex align-items-center justify-content-between gap-3 pt-3">
                                      <h4 className="m-0 p-0">{dashboardData.totalUsers}</h4>
                                      {dashboardData.totalUsers > 0 && (
                                        <Tooltip title="View more">
                                          <span
                                            onClick={() => {
                                              setActiveTab("Users");
                                              setRedirected(true);
                                            }}
                                            className="enlargebtn"
                                          >
                                            <ExpandDetailsIcon />
                                          </span>
                                        </Tooltip>
                                      )}
                                    </span>
                                  )}
                                </div>
                                <div className="welcometext ">
                                  <p>{loading ? <Skeleton width="5vw" /> : <> Platform Visits </>} </p>
                                  {loading ? (
                                    <Skeleton width="5vw" />
                                  ) : (
                                    <span className="d-flex align-items-center justify-content-between gap-3 pt-3">
                                      <h4 className="m-0 p-0">{dashboardData.platformVisit}</h4>
                                      {dashboardData.platformVisit > 0 && (
                                        <Tooltip title="View more">
                                          <span
                                            onClick={() =>
                                              navigate(
                                                `/team/visits/list/${uuid}?filter=${filter}&type=visits&view=team`,
                                                { state: { name: state.name, avatar: state.avatar } }
                                              )
                                            }
                                            className="enlargebtn"
                                          >
                                            <ExpandDetailsIcon />
                                          </span>
                                        </Tooltip>
                                      )}
                                    </span>
                                  )}
                                </div>
                                <div className="welcometext ">
                                  <p>{loading ? <Skeleton width="5vw" /> : <> Events </>} </p>
                                  {loading ? (
                                    <Skeleton width="5vw" />
                                  ) : (
                                    <span className="d-flex align-items-center justify-content-between gap-3 pt-3">
                                      <h4 className="m-0 p-0">{dashboardData.totalEvents}</h4>
                                      {dashboardData.totalEvents > 0 && (
                                        <Tooltip title="View more">
                                          <span
                                            onClick={() =>
                                              navigate(
                                                `/team/event/list/${uuid}?filter=${filter}&type=eventsList&view=team`,
                                                { state: { name: state.name, avatar: state.avatar } }
                                              )
                                            }
                                            className="enlargebtn"
                                          >
                                            <ExpandDetailsIcon />
                                          </span>
                                        </Tooltip>
                                      )}
                                    </span>
                                  )}
                                </div>
                                <div className="welcometext">
                                  <p>{loading ? <Skeleton width="5vw" /> : <> Average Session Time </>}</p>
                                  {loading ? (
                                    <Skeleton width="5vw" />
                                  ) : (
                                    <span className="d-flex align-items-center justify-content-between gap-3 pt-3">
                                      <h4 className="m-0 p-0"> {humanReadable(dashboardData.avgSessionTime)} </h4>
                                      {dashboardData.avgSessionTime !== null && (
                                        <Tooltip title="View more">
                                          <span
                                            onClick={() =>
                                              navigate(
                                                `/team/session/list/${uuid}?filter=${filter}&type=session&view=team`,
                                                { state: { name: state.name, avatar: state.avatar } }
                                              )
                                            }
                                            className="enlargebtn"
                                          >
                                            <ExpandDetailsIcon />
                                          </span>
                                        </Tooltip>
                                      )}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-3 pe-0 h-100">
                          <div className="col-md-9 h-100">
                            <div className="row h-100">
                              <div className="col-md-6 h-100">
                                <div className="graphbox overflow-hidden custom-chart">
                                  <span className="d-flex align-item-center justify-content-between">
                                    <p> {loading ? <Skeleton width="40%" /> : <> Popular Environment </>}</p>
                                  </span>
                                  {loading ? (
                                    <Skeleton count={1} height="33vh" width="100%" />
                                  ) : (
                                    <PopEnv data={dashboardData.popularEnvironment} Dashboard="team" />
                                  )}
                                </div>
                              </div>
                              <div className="col-md-6 mx-0 ps-2 h-100">
                                <div className="graphbox overflow-hidden custom-chart">
                                  <p> {loading ? <Skeleton width="40%" /> : <> Most Visited Places </>}</p>
                                  {loading ? (
                                    <Skeleton count={1} height="33vh" width="100%" />
                                  ) : (
                                    <MostVisited Places={dashboardData.mostVisitedPlaces} Dashboard="team" />
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="row mt-3 h-100">
                              <div className="col-md-12 h-100">
                                <div className="graphbox overflow-hidden custom-chart">
                                  <p> {loading ? <Skeleton width="40%" /> : <> Active Time </>}</p>
                                  {loading ? (
                                    <Skeleton count={1} height="33vh" width="100%" />
                                  ) : (
                                    <ActiveHours data={dashboardData.activeHours} Dashboard="team" />
                                  )}
                                </div>
                              </div>
                              {/* <div className='col-md-6 mx-0 ps-2 h-100'>
                                                                <div className="graphbox overflow-hidden custom-chart">
                                                                    <p> {loading ? <Skeleton width="40%" /> : <>Session Analytics</>}</p>
                                                                    {loading ? <Skeleton count={1} height="33vh" width="100%" /> :
                                                                        <>
                                                                            <Sessions sessions={dashboardData.sessionCreated} Dashboard="team" />
                                                                        </>
                                                                    }
                                                                </div>
                                                            </div> */}
                            </div>
                          </div>
                          <div className="col-md-3 ps-0 h-100">
                            <div className="col-md-12 mx-0 ps-2 h-100">
                              <div className="graphbox overflow-hidden custom-chart">
                                <span>
                                  <p> {loading ? <Skeleton width="5vw" /> : <> Platform Visits </>}</p>
                                  <p className="addsome" style={{ textDecoration: "none" }}>
                                    {loading ? (
                                      <Skeleton width="5vw" />
                                    ) : (
                                      <>
                                        {" "}
                                        <span style={{ color: "#333" }}> Total : </span> {dashboardData.platformVisit}{" "}
                                      </>
                                    )}
                                  </p>
                                </span>
                                {loading ? (
                                  <Skeleton count={1} height="33vh" width="100%" />
                                ) : (
                                  <PlatformVisit platform={dashboardData.platform} />
                                )}
                              </div>
                            </div>
                            <div className="col-md-12 mx-0 ps-2 mt-3 h-100">
                              <div className="graphbox overflow-hidden custom-chart">
                                <p> {loading ? <Skeleton width="40%" /> : <> User Engagement </>}</p>
                                {loading ? (
                                  <Skeleton count={1} height="33vh" width="100%" />
                                ) : (
                                  <UsersRadial
                                    newVisitors={dashboardData.newVisitors}
                                    activeUsers={dashboardData.activeUsers}
                                    inActiveUsers={dashboardData.totalUsers - dashboardData.activeUsers}
                                  />
                                )}
                              </div>
                            </div>
                            {/* <div className="graphbox overflow-hidden custom-chart " style={{ minHeight:"100%" }}>

                                                            

                                                            {loading ?
                                                                <Skeleton count={1} height="30vh" width="100%" className='mb-3' />
                                                                :
                                                                <PlatformVisit platform={dashboardData.platform} />
                                                            }
                                                          

                                                            <div className="user-specific">
                                                            <p> {loading ? <Skeleton width="40%" /> : <> Users </>}</p>
                                                            {loading ?
                                                                <div className='w-100 d-flex align-item-center justify-content-center'>
                                                                    <Skeleton count={1} circle height="17vh" width="17vh" className='mb-3' />
                                                                </div>
                                                                :
                                                                <div style={{ position:"relative" }}>
                                                                <NewPlatUsers newVisitors={dashboardData.newVisitors} />
                                                                </div>
                                                            }

                                                            {loading ?
                                                                <div className='w-100 d-flex align-item-center justify-content-center'>
                                                                    <Skeleton count={1} circle height="17vh" width="17vh" className='mb-3' />
                                                                </div>
                                                                :
                                                                <div style={{ position:"relative" }}>
                                                                <ActivePlatUsers activeUsers={dashboardData.activeUsers} />
                                                                </div>
                                                            }

                                                        
                                                            </div> 
                                                             </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab.Pane>

                <Tab.Pane eventKey="Groups">
                  <GroupsTab
                    groupTypesList={groupTypesList}
                    setSearch={setSearch}
                    search={search}
                    onSelect={(group) => onGroupSelect(group)}
                  />
                </Tab.Pane>

                <Tab.Pane eventKey="Users">
                  <UsersTab
                    roleList={roleList}
                    setSearch={setSearch}
                    search={search}
                    onSelect={(user) => onUserSelect(user)}
                    setActiveTab={setActiveTab}
                    redirected={redirected}
                    setRedirected={setRedirected}
                  />
                </Tab.Pane>
              </Tab.Content>
            </div>
          </Tab.Container>
        </div>
      </div>
    </>
  );
};

export default TeamDashboard;
